<template>
  <div class="result-item post" @click="goToPost">
    <v-image :default="'DefaultCommunityVisual.png'" :image-id="post.idImage" />
    <div class="item-info">
      <post-search :post="post" />
    </div>
  </div>
</template>

<script>
import PostSearch from './PostSearch'
import VImage from '../shared/VImage'

export default {
  name: 'SearchResultPostItem',
  components: { PostSearch, VImage },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToPost () {
      this.$router.push({ name: 'postPage', params: { id: this.post.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
img {
    width: 100px;
    height: 75px;
    object-fit: cover;
    object-position: 20% 20%;
}

.result-item {
    display: flex;
    padding: 15px 0;
    cursor: pointer;

    &.post {
        align-items: flex-start;
    }

    .item-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        color: $black-color;
        font-size: 15px;
        margin-left: 10px;
        max-width: 750px;
    }
}

</style>
